(() => {
  'use strict';

  const ROOT_SELECTOR = '.ifc-wrap';

  const errorIdFor = (input) => `${input.id || 'ifc-weight'}-error`;

  const clearFieldError = (root) => {
    const input = root ? root.querySelector('#ifc-weight') : null;
    if (!input) return;

    const errorId = errorIdFor(input);
    const error = root.querySelector(`#${errorId}`);
    if (error) error.remove();

    input.removeAttribute('aria-invalid');

    const describedBy = (input.getAttribute('aria-describedby') || '')
      .split(/\s+/)
      .filter(Boolean)
      .filter((id) => id !== errorId);

    if (describedBy.length) {
      input.setAttribute('aria-describedby', describedBy.join(' '));
    } else {
      input.removeAttribute('aria-describedby');
    }
  };

  const showFieldError = (root) => {
    const input = root ? root.querySelector('#ifc-weight') : null;
    if (!input) return;

    clearFieldError(root);

    const min = Number.parseFloat(input.min);
    const max = Number.parseFloat(input.max);
    const minText = Number.isFinite(min) ? min : 3;
    const maxText = Number.isFinite(max) ? max : 50;
    const errorId = errorIdFor(input);
    const error = document.createElement('p');

    error.id = errorId;
    error.className = 'ifc-field-error form__message';
    error.setAttribute('role', 'alert');
    error.textContent = `Masukkan berat antara ${minText} kg hingga ${maxText} kg.`;

    input.setAttribute('aria-invalid', 'true');

    const describedBy = (input.getAttribute('aria-describedby') || '')
      .split(/\s+/)
      .filter(Boolean);

    if (!describedBy.includes(errorId)) describedBy.push(errorId);
    input.setAttribute('aria-describedby', describedBy.join(' '));

    const field = input.closest('.ifc-field') || input.parentElement;
    if (field) field.appendChild(error);

    input.focus();
  };

  const clearResult = (root) => {
    const result = root ? root.querySelector('#ifc-result') : null;
    if (!result) return;
    result.replaceChildren();
    result.classList.remove('show', 'error');
  };

  const isWeightInvalid = (input) => {
    const value = Number.parseFloat(input.value);
    const min = Number.parseFloat(input.min);
    const max = Number.parseFloat(input.max);

    if (!Number.isFinite(value)) return true;
    if (Number.isFinite(min) && value < min) return true;
    if (Number.isFinite(max) && value > max) return true;
    return false;
  };

  document.addEventListener('input', (event) => {
    const input = event.target instanceof Element ? event.target.closest('#ifc-weight') : null;
    if (!input) return;

    const root = input.closest(ROOT_SELECTOR);
    if (!root) return;

    clearFieldError(root);
  }, true);

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const button = target ? target.closest('.ifc-btn') : null;
    if (!button) return;

    const root = button.closest(ROOT_SELECTOR);
    const input = root ? root.querySelector('#ifc-weight') : null;
    if (!root || !input) return;

    if (isWeightInvalid(input)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      clearResult(root);
      showFieldError(root);
      return;
    }

    clearFieldError(root);
  }, true);

  document.addEventListener('keydown', (event) => {
    const input = event.target instanceof Element ? event.target.closest('#ifc-weight') : null;
    if (!input || event.key !== 'Enter') return;

    const root = input.closest(ROOT_SELECTOR);
    if (!root) return;

    if (isWeightInvalid(input)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      clearResult(root);
      showFieldError(root);
      return;
    }

    clearFieldError(root);
  }, true);
})();